import { render, staticRenderFns } from "./SharedFolderShow.vue?vue&type=template&id=f92c1ea0&scoped=true&"
import script from "./SharedFolderShow.vue?vue&type=script&lang=js&"
export * from "./SharedFolderShow.vue?vue&type=script&lang=js&"
import style0 from "./SharedFolderShow.vue?vue&type=style&index=0&id=f92c1ea0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92c1ea0",
  null
  
)

export default component.exports